'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import { getVerifyCalendarsSucceeded } from 'MeetingsAdmin/selectors/RequestStatusSelector';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Link } from 'foundations-components/transitional/components/Link';
import { getMeetingsSettingsLink } from '../../utils/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function MultipleCalendarWarning() {
  const meetingsUser = useSelector(state => state.meetingsUser);
  const verifyCalendarsSucceeded = useSelector(state => getVerifyCalendarsSucceeded(state));
  if (!verifyCalendarsSucceeded || !meetingsUser || meetingsUser.unavailableCalendarIds.size === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Alert, {
    type: "warning",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "calendarView.multipleCalendarsWarning.title"
    }),
    padding: "500",
    marginBlockEnd: "400",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "calendarView.multipleCalendarsWarning.body"
    }), /*#__PURE__*/_jsx(Link, {
      external: true,
      href: getMeetingsSettingsLink(),
      marginInlineStart: "300",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "calendarView.multipleCalendarsWarning.action"
      })
    })]
  });
}